import Media from '@linc-technologies/linced-common/models/media';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Globalnotice from 'linced-admin/models/posts/globalnotice';

export default class _Media extends Media {
  declare [Type]: 'media';

  @belongsTo('posts/globalnotice', { async: true, inverse: 'mediaIds' })
  // @ts-expect-error the linced-admin globalnotice changes groupIds (see there).
  declare globalNoticeId: AsyncBelongsTo<Globalnotice>;
}
